import { render, staticRenderFns } from "./PortIdentifying.vue?vue&type=template&id=2b1fcaa1&scoped=true&"
import script from "./PortIdentifying.vue?vue&type=script&lang=js&"
export * from "./PortIdentifying.vue?vue&type=script&lang=js&"
import style0 from "./PortIdentifying.vue?vue&type=style&index=0&id=2b1fcaa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1fcaa1",
  null
  
)

export default component.exports